import { flattenDeep } from 'lodash';
import { ObjectId } from './engine.nodes.state.model';

declare const Human;

function getAllChildren(_Human, object): ObjectId[] {
  const children = object.objects;

  if (children.length === 0) {
    return [];
  }

  return flattenDeep(
    children.map(child => {
      return [
        child.objectId,
        ...getAllChildren(_Human, _Human.scene.objects[child.objectId])
      ];
    })
  );
}

export function setAllChildren(objectId, nodes, prop, value) {
  getAllChildren(Human, Human.scene.objects[objectId]).forEach(
    childId => (nodes[childId][prop] = value)
  );
}
